import TemplateView from '../../../../../TemplateView'
import messageResource from '../../../../../messageResource'
import {hostingZone} from '../../../constants'
import CustomRadioButton from '../CustomRadioButton'

export default class HostingZoneSelector extends TemplateView {
    constructor({
        onHostingZoneChanged = () => {},
    } = {}) {
        super()

        this.callbacks = {
            onHostingZoneChanged,
        }

        this.state = {
            hostingZone: '',
            euOnly: false,
        }

        this.onStatePropertyChanged('hostingZone', (zone) => {
            this.northAmericaRadio.setState({selected: zone === hostingZone.NORTH_AMERICA})
            this.europeRadio.setState({selected: zone === hostingZone.EUROPE})
        })

        this.onStatePropertyChanged('euOnly', (euOnly) =>{
            this.$chooseZone.toggle(!euOnly)
            this.$euZoneOnly.toggle(euOnly)
        })
    }

    templateHtml() {
        return '<div class="hostingZoneSelector">' +
               '    <div class="chooseZone">' +
               '        <div class="selectors">' +
               '            <div class="northAmericaSelector"/>' +
               '            <div class="europeSelector"/>' +
               '        </div>' +
               '        <div class="note"><%=chooseZoneNote%></div>' +
               '    </div>' +
               '    <div class="euZoneOnly">' +
               '        <div class="frameTitle"><%=europeOnlyTitle%></div>' +
               '        <div class="note"><%=europeOnlyNote%></div>' +
               '    </div>' +
               '</div>'
    }

    messageKeys() {
        return {
            europeLabel: 'licenses.purchase_lightbox.choose_hosting_zone.europe',
            chooseZoneNote: 'licenses.purchase_lightbox.choose_hosting_zone.note',
            europeOnlyTitle: 'licenses.purchase_lightbox.choose_hosting_zone.europe_only',
            europeOnlyNote: 'licenses.purchase_lightbox.choose_hosting_zone.europe_only_note',
        }
    }

    afterRender() {
        this.$chooseZone = this.find('.chooseZone')
        this.$euZoneOnly = this.find('.euZoneOnly')
        this.$euZoneOnly.hide()

        this.northAmericaRadio = new CustomRadioButton({
            onChangeCallback: () => this.callbacks.onHostingZoneChanged(hostingZone.NORTH_AMERICA),
            label: messageResource.getMessage('licenses.purchase_lightbox.choose_hosting_zone.america'),
            name: 'hostingZone',
        }).init(this.find('.northAmericaSelector'))

        this.europeRadio = new CustomRadioButton({
            onChangeCallback: () => this.callbacks.onHostingZoneChanged(hostingZone.EUROPE),
            label: messageResource.getMessage('licenses.purchase_lightbox.choose_hosting_zone.europe'),
            name: 'hostingZone',
        }).init(this.find('.europeSelector'))
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/purchaseLightBox/accountInfo/HostingZoneSelector.js